import { literal, union, TypeOf } from 'io-ts';

export const LanguageValidator = union([literal('en'), literal('es')], 'LanguageType');
export type Language = TypeOf<typeof LanguageValidator>;
